// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { EMP_WEEKLY_TIMESHEET } from '../../config/API_Collection';
import { getErrorMessage } from '../../config/Error_Codes';
import { GET_WEEKLY_TS_FAILURE, GET_WEEKLY_TS_REQUEST, GET_WEEKLY_TS_SUCCESS } from '../Actions/Actions';



function* fetchTasks() {
  try {
    const response = yield call(Axios.get,EMP_WEEKLY_TIMESHEET);
    console.warn(response);
    
    const projects = response.data.data || [];
    yield put({type:GET_WEEKLY_TS_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:GET_WEEKLY_TS_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* weeklyTimesheetSaga() {
  yield takeLatest(GET_WEEKLY_TS_REQUEST, fetchTasks);
}
